module.exports = __webpack_public_path__ + "static/media/spotlights.c0dfbaa2.svg";